export default __webpack_public_path__ + "static/media/TopBarComment.dd21e1be.svg";